<template>
	<div class="contentbox" style="padding-top: 10px;">
		<ul class="tabs-ul-list">
			<li v-for="(item, index) in tabName" :key="index">
				<a :class="item.value === selectaVal ? 'active' : ''" @click="tabClick(item.value,item.name)">{{item.name}}</a>
			</li>
		</ul>
		<div class="tabs-ul-con" style="padding-top: 30px;">
			<!-- <router-view></router-view> -->
			<dp-subscribe-month v-if="selectaVal==1"></dp-subscribe-month>
			<dp-subscribe-user v-if="selectaVal==2"></dp-subscribe-user>
		</div>
		<!--<agent-pop :visible.sync="isShowDialogAgent"></agent-pop>-->
	</div>
</template>
<script>
    import DpSubscribeMonth from '@/views/wb/user/DpSubscribeMonth'
    import DpSubscribeUser from '@/views/wb/user/DpSubscribeUser'
    export default {
        components: {
            DpSubscribeMonth,
            DpSubscribeUser
        },
        data() {
            return {
                tabName: [
                    // {
                    //     value: 1,
                    //     name: '按月统计'
                    // },
					{
                        value: 2,
                        name: '按用户统计'
                    }
                ],
                selectaVal:2,
                isShowDialogAgent:true,
            }
        },
        computed: {},
        watch: {
        },
        created(){
            if(JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
                this.isShowDialogAgent = false
            } else {
                this.isShowDialogAgent = true
            }
        },
        mounted: function() {
            console.log(this.$route)
        },
        methods: {
            tabClick (value, name) {
                // this.$router.push({ path:  path})
                this.selectaVal = value
                console.log(name)
            }
        }
    }
</script>
<style lang="sass">

</style>
